import React, {Component} from "react"
import {setLanguage} from "../actions/userActions";
import {connect} from "react-redux";
import {languages} from "../utils/common";
import Dropdown from "semantic-ui-react/dist/commonjs/modules/Dropdown";
import {Icon, Menu} from "semantic-ui-react";

const mapStateToProps = (state, ownProps) => {
    const {user} = state;
    return {
        lang: user.lang,
        ...ownProps
    }
};

class LanguageSelector extends Component {
    constructor(props) {
        super(props);
        let value = languages.ENGLISH;
        if(!!props.lang){
            value = props.lang;
        }
        this.state = {
            value,
        }
    }

    handleOnChange = ({value}) => {
        const {dispatch} = this.props;
        this.setState({value});
        dispatch(setLanguage(value));
        document.title = value === languages.SPANISH? "Inscripción" : "Enrollment";
    };

    render() {
        const {value} = this.state;
        const english = 'English';
        const spanish = 'Spanish';
        const englishTranslation = 'Inglés'
        const spanishTranslation = 'Español'
        let currentDisplayText = english;
        let alternateDisplayText = spanish;
        let alternateValue = languages.SPANISH;
        if(value === languages.SPANISH){
            currentDisplayText = spanishTranslation;
            alternateDisplayText = englishTranslation;
            alternateValue = languages.ENGLISH;
        }
        return (
            <Menu.Item as={Dropdown} floating direction={"left"} trigger={<span><Icon name='globe'/> {currentDisplayText}</span>}>
                <Dropdown.Menu>
                    <Dropdown.Item text={alternateDisplayText} onClick={()=>this.handleOnChange({value: alternateValue})}/>
                </Dropdown.Menu>
            </Menu.Item>
        )
    }
}

export default connect(mapStateToProps)(LanguageSelector);
